export default function setupRedirects() {
  const redirects = document.querySelectorAll('a[data-redirect-url]');
  redirects.forEach((link) => {
    link.href = link.dataset.redirectUrl; // eslint-disable-line no-param-reassign
  });
}
